import { range } from 'common/utils/range'
export const DEFAULT_SIZE_TEXT = '선택하세요.'
export const initialSizeValue = 9999
export const heights: number[] = [...range(139, 191)]
export const weights: number[] = [...range(34, 101)]
export const shoeSizes: number[] = [...range(215, 305, 5)]
export const topSizes: string[] = ['XS', 'S', 'M', 'L', 'XL']
export const bottomSizes: number[] = [...range(23, 36), ...range(38, 50, 2)]

export const getHeightDisplayValue = (height: number) => {
  if (height < 140) {
    return '140미만'
  }
  if (height > 190) {
    return '190초과'
  }
  return height
}
export const getWeightDisplayValue = (weight: number) => {
  if (weight < 35) {
    return '35미만'
  }
  if (weight > 100) {
    return '100초과'
  }
  return weight
}
export const getShoeDisplayValue = (shoeSize: number) => {
  return shoeSize < 220 ? '220미만' : shoeSize > 300 ? '300초과' : shoeSize
}
export const getBottomsDisplayValue = (bottom: number) => {
  if (bottom > 48) {
    return '50이상'
  }
  return bottom
}
